import type { ReactNode } from "react";
import { Icon, ThemeToggle, Wordmark } from "@vavr/ui";

/** Web account framing only. App sign-in screens keep their own layout. */
export function WebAccountFrame({ children, signup }: { children: ReactNode; signup: boolean }) {
  return (
    <div className="web-account">
      <aside className="web-account__story">
        <a className="web-account__brand" href="https://vavr.us" aria-label="Vavr website"><Wordmark withMark name="vavr." /></a>
        <div className="web-account__message">
          <span className="web-eyebrow">A LITTLE CERTAINTY. EVERY SCHOOL DAY.</span>
          <p className="web-account__headline">{signup ? "A calmer day" : "Your school day,"}<br /><em>{signup ? "starts here." : "connected."}</em></p>
          <p className="web-account__description">Children, families and your team. One place to keep the day moving and every handover in view.</p>
          <div className="web-account__illustration" aria-hidden="true">
            <div className="web-account__orbit" />
            <span className="web-account__sun"><svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="8" strokeLinecap="round"><path d="M50 8v84M8 50h84M20 20l60 60M20 80l60-60" /></svg></span>
            <div className="web-account__tile"><Icon name="shield" /><span>Care at the centre.<strong>Trust in every handover.</strong></span></div>
          </div>
        </div>
        <div className="web-account__foot"><Icon name="lock" /><span>Built for the people who care for them.</span></div>
      </aside>
      <div className="web-account__content">
        <div className="web-account__tools"><a href="https://vavr.us/support">Need a hand? <span aria-hidden="true">↗</span></a><ThemeToggle /></div>
        {children}
        <nav className="web-account__legal" aria-label="Information"><a href="https://vavr.us/privacy">Privacy</a><a href="https://vavr.us/terms">Terms</a><a href="https://vavr.us/trust">Trust &amp; security</a></nav>
      </div>
    </div>
  );
}
